import React from 'react'
import carousalImage  from './Images/contactCarousal.jpg'
export default function ContactCarousal() {
    return(
        <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="false">
          
        <div class="carousel-inner">
            <div class="carousel-item active">
                <img src={carousalImage} class="d-block w-100" alt="..."/>
                    <div class="carousel-caption d-md-block theBox" style={{fontSize:'8vh'}}>
                        <h1 style={{fontSize:'8vh'}}>GET IN TOUCH WITH US.</h1>
                        <h4 style={{fontSize:'8vh'}}>Contact The Construction Company</h4>
                    </div>
            </div>
          
        </div>
       
    </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/contactCarousal.jsx